import { Callout } from "@clipboard-health/ui-components";
import { RootPaths } from "@src/appV2/App/paths";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { minutesToMilliseconds } from "date-fns";
import pluralize from "pluralize";
import { useHistory } from "react-router-dom";

import { useIsInHomeEnabled } from "../../InHome/lib/useIsInHomeEnabled";
import { useWorkerPendingVisitInvites } from "../../InHome/VisitInvites/api/useWorkerPendingVisitInvites";
import { useWorkerPendingShiftInvites } from "../../WorkerShifts/ShiftInvites/api/useWorkerPendingShiftInvites";

export function ShiftInvitesCallout() {
  const history = useHistory();
  const isInHomeEnabled = useIsInHomeEnabled();

  const queryOptions = {
    // The shift discovery page remains mounted when opening shifts in bottom sheets,
    // preventing automatic refetches of the query on mount. Setting a stale time ensures invites
    // are periodically refreshed even without unmounting.
    staleTime: minutesToMilliseconds(2),
  };

  const { data: shiftInvitesData, isSuccess: isShiftInvitesSuccess } = useWorkerPendingShiftInvites(
    {
      options: queryOptions,
    }
  );

  const { data: visitInvitesData, isSuccess: isVisitInvitesSuccess } = useWorkerPendingVisitInvites(
    {
      options: {
        ...queryOptions,
        enabled: isInHomeEnabled,
      },
    }
  );

  const shiftInviteCount = isShiftInvitesSuccess ? shiftInvitesData.data.length : 0;
  const visitInviteCount =
    isInHomeEnabled && isVisitInvitesSuccess ? visitInvitesData.data.length : 0;
  const totalInviteCount = shiftInviteCount + visitInviteCount;

  if (totalInviteCount <= 0) {
    return null;
  }

  return (
    <Callout
      title={`${totalInviteCount} ${pluralize("Invite", totalInviteCount)}`}
      iconType="invite"
      sx={(theme) => ({
        backgroundColor: theme.palette.shift?.priority.background,
        color: theme.palette.shift?.priority.text,
      })}
      onClick={() => {
        logEvent(APP_V2_USER_EVENTS.OPEN_SHIFTS_CALLOUT_VIEWED, {
          type: "shiftInvite",
          count: shiftInviteCount,
          visitInviteCount,
          totalCount: totalInviteCount,
        });
        history.push(`${RootPaths.APP_V2_HOME}/myShifts/shiftInvites`);
      }}
    />
  );
}
